// extracted by mini-css-extract-plugin
export default {"row":"TasksPanelTable_row__0ZIYV"};